import ChatbotAPI from 'api/chatbot.api';
import { BaseHandler } from './base.handler';
import { type ConversationAPIPayloadType } from 'views/Chatbot/types/chatbot.request.types';
import { type ConversationAPIResponseType } from 'views/Chatbot/types/chatbot.response.types';

export default class ChatbotHandler extends BaseHandler {
  private readonly api: ChatbotAPI;

  constructor() {
    super();
    this.api = new ChatbotAPI();
  }

  async conversation(
    payload: ConversationAPIPayloadType
  ): Promise<ConversationAPIResponseType> {
    const errorMsg = 'Error while getting response!';
    try {
      const response = await this.api.conversation(payload);
      if (response?.response) {
        return response;
      } else {
        throw new Error('Error while getting response!');
      }
    } catch (_) {
      this.handleError(errorMsg);
      throw new Error(errorMsg);
    }
  }
}
